import { render, staticRenderFns } from "./TransactionCard.vue?vue&type=template&id=723349cc&scoped=true&"
import script from "./TransactionCard.vue?vue&type=script&lang=js&"
export * from "./TransactionCard.vue?vue&type=script&lang=js&"
import style0 from "./TransactionCard.vue?vue&type=style&index=0&id=723349cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723349cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VLayout})
